
export enum plinthType {
    none = 'none',
    C = 'C',
    Custom = 'Custom'
}